
















import Vue from "vue";
import { mapGetters } from "vuex";
import { regulationsOptionsData } from "@/shared/scripts/helpers/regulations/regulationsOptions.data";
import iwInputRadioGroup from "@/encoding/components/buildingBlocks/InputRadioGroup.vue";

export default Vue.extend({
    name: "AsbestosCertificateAvailable",

    components: {
        iwInputRadioGroup: iwInputRadioGroup
    },

    computed: {
        ...mapGetters({
            getClassifiedProperty: "FormModule/getValue",
            getError: "FormModule/getErrorObjectByPath"
        }),

        asbestosCertificateAvailablePath: function(): string {
            return "property.certificates.hasAsbestosCertificate";
        },

        options: function(): Array<{ value: string | boolean; label: string }> {
            return regulationsOptionsData();
        },

        errorMessage: function(): string {
            return this.getError(this.asbestosCertificateAvailablePath);
        },
        value: function(): string | boolean {
            const current = this.getClassifiedProperty(this.asbestosCertificateAvailablePath);
            if (current === true) return true;
            if (current === false) return false;
            return "not_specified";
        }
    },

    methods: {
 
        updateValue: function(selectedValue: string | boolean): void {
            if (selectedValue === "not_specified") {
                this.$store.commit("FormModule/deleteValue", this.asbestosCertificateAvailablePath);
            } else if (selectedValue === true || selectedValue === false) {
                this.$store.dispatch("FormModule/addValue", {
                    path: this.asbestosCertificateAvailablePath,
                    value: selectedValue
                });
            }
        }

    }
});
